@if (links.live) {
    <ms-list-item
        icon="theme-live"
        iconSize="16"
        [msAutomation]="'live'"
        [title]="links.live.title"
        [count]="links.live.count"
        [href]="links.live.url"
        [arrow]="true" />
}

@if (links.today) {
    <ms-list-item [msAutomation]="'calendar-today'" [title]="links.today.title" [count]="links.today.count" [href]="links.today.url" [arrow]="true">
        <span item-icon class="theme-current-date">{{ date | date: 'MMM' }}<br />{{ date | date: 'dd' }}</span>
    </ms-list-item>
}

@if (links.all) {
    <ms-list-item
        icon="sports-all"
        iconSize="16"
        [msAutomation]="'az-sports'"
        [title]="links.all.title"
        [count]="links.all.count"
        [arrow]="true"
        (click)="openSportsPopup()" />
}

@if (links.home) {
    <ms-list-item icon="theme-home" iconSize="16" [msAutomation]="'home-page'" [title]="links.home.title" [href]="links.home.url" [arrow]="true" />
}
